module.exports = __webpack_public_path__ + "static/media/logo.b0344a12.png";